(function () {
  function init(root) {
    if (root.dataset.sxqReady) return;
    root.dataset.sxqReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sxq-item]'));

    function set(item, open) {
      item.classList.toggle('is-open', open);
      var b = item.querySelector('button');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var b = item.querySelector('button');
      b.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        items.forEach(function (o) { if (o !== item) set(o, false); });
        set(item, open);
      });
    });

    var cat = '';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sxq-tab]'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        cat = t.dataset.sxqTab;
        tabs.forEach(function (o) { o.classList.toggle('is-on', o === t); });
        filter();
      });
    });

    var input = root.querySelector('[data-sxq-search]');
    var none = root.querySelector('[data-sxq-none]');
    function filter() {
      var t = input ? input.value.trim().toLowerCase() : '';
      var shown = 0, firstHit = null;
      items.forEach(function (item) {
        var hit = (!t || item.textContent.toLowerCase().indexOf(t) > -1) && (!cat || item.dataset.cat === cat);
        item.hidden = !hit;
        if (hit) { shown++; if (!firstHit) firstHit = item; }
      });
      if ((t || cat) && firstHit) { items.forEach(function (o) { set(o, o === firstHit); }); }
      if (none) none.hidden = shown > 0;
    }
    if (input) input.addEventListener('input', filter);
  }

  function boot() { document.querySelectorAll('[data-sxq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
